module.exports = __webpack_public_path__ + "img/roccathorde.eb09d24a.jpg";